export default __webpack_public_path__ + "static/media/buzz.d02f6879.svg";